import TextBox from "components/TextBox";
import MasterPage2Column from "pages/MasterPage2Column"
import * as urls from "../../../../src/api/urls";
import { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import AppSimpleBar from "components/AppSimpleBar";
import Loader from "components/Loader";
import DatePicker from "react-datepicker";
import classnames from "classnames";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import LoadingIconWithText from "components/LoadingIconWithText";
import { QuickReplyContentTypes as Types } from "const";

interface tb_QuickReply {
  quickReplyId?: number | null;
  category?: string | null;
  name?: string | null;
  keyword?: string | null;
  description?: string | null;
  avaliableFrom?: Date | null;
  avaliableTo?: Date | null;
  createBy?: number | null;
  createDate?: Date | null;
  updateBy?: number | null;
  updateDate?: Date | null;
  usedCount?: number | null;
  enabled?: boolean | null;
  active?: boolean | null;
  items?: tb_QuickReplyItem[] | null;
}

interface tb_QuickReplyItem {
  uid?: string;
  quickReplyId?: number | null;
  seq?: number | null;
  contentType?: Types;
  contents?: string | null;
  contentName?: string | null;
  enabled?: boolean | null;
}

interface ModalData {
  uid?: string;
  contentType?: Types;
  contentName?: string | null;
  text?: string | null;
  sticker?: string | null;
  picture?: string | null;
  linkUrl?: string | null;
  linkCaption?: string | null;
}

const CategoryList: React.FC<
  { onClickItem(editId: number | null): void, editId: number, isSearching: boolean, categories: any[], onSearch(filter: string): void, canEdit: boolean }> =
  ({ onClickItem, editId, isSearching, categories, onSearch, canEdit }) => {
    const [filter, setFilter] = useState<string>("");
    return (
      <>
        <div className="mpage-2col-header">
          <div>รายการคลังคำตอบ</div>
          <div>
            {/* <i className="fas fa-plus-circle hover hand" onClick={() => { onClickItem(-1) }}></i>&nbsp; */}
            {canEdit && (
              <button className="btn btn-pc btn-warning" onClick={() => { onClickItem(-1) }} >เพิ่มใหม่</button>
            )}
            {/* <i className="fas fa-redo-alt" onClick={() => { }}></i> */}
          </div>
        </div>
        <TextBox placeholder="กรอง/ค้นหา" className="form-control p-1" icon13small={true} icon13css="fas fa-search" onEnter13={(e) => onSearch(filter)} value={filter} onChange={(e) => setFilter(e.target.value)} />
        <AppSimpleBar className="mt-1" style={{ height: "calc(100vh - 160px)" }}>
          {isSearching && (<Loader />)}
          {categories.length <= 0 && (<div className="text-center">-- ยังไม่มีข้อมุล --</div>)}
          <div className="d-flex flex-column" style={{ gap: "4px" }}>
            {categories.map((cat, index) => {
              return (
                <div key={index}
                  className={classnames("dset-qr-cat hover hand d-flex justify-content-between align-items-center", { "active-primary": editId === cat.quickReplyId, "text-secondary": !cat.active })}
                  onClick={() => onClickItem(cat.quickReplyId)}
                >
                  <div style={{ flex: "1" }}>
                    {cat.name}
                  </div>
                  <div>
                    <span className="fz-08 text-secondary">{cat.usedCount && Utils.FormatNumber(cat.usedCount, 0)}</span>
                  </div>
                </div>
              )
            })}
          </div>
        </AppSimpleBar>

      </>);
  }

const CategoryEdit: React.FC<{ editId: number | null, onCatChange(quickReplyId: number, data: tb_QuickReply | null): void, canEdit: boolean }> = ({ editId, onCatChange, canEdit }) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const [editData, setEditData] = useState<tb_QuickReply | null>(null);
  const [editItems, setEditItems] = useState<tb_QuickReplyItem[]>([]);
  const [modalData, setModalData] = useState<ModalData | null>(null);
  const [modalSaving, setModalSaving] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const iconShowMore = showMore ? "fas fa-angle-double-up" : "fas fa-angle-double-down";
  const stickerList: string[] = [
    "/icons/stk/555.png",
    "/icons/stk/Annoucement.png",
    "/icons/stk/AppreciateYourHelp.png",
    "/icons/stk/Bye.png",
    "/icons/stk/CallBackLater.png",
    "/icons/stk/CarIsGoing.png",
    "/icons/stk/Checking.png",
    "/icons/stk/CheckOrder.jpeg",
    "/icons/stk/Confirm.png",
    "/icons/stk/Cry.png",
    "/icons/stk/Deliveried.png",
    "/icons/stk/Document.png",
    "/icons/stk/Done1.png",
    "/icons/stk/Done2.png",
    // "/icons/stk/EV1.png",
    // "/icons/stk/EV2.PNG",
    // "/icons/stk/EV3.PNG",
    "/icons/stk/Execelent.png",
    "/icons/stk/HappyBirthDay.png",
    "/icons/stk/Hello.png",
    "/icons/stk/Hello2.png",
    "/icons/stk/Hi.PNG",
    "/icons/stk/Hurry.png",
    "/icons/stk/Love.png",
    "/icons/stk/Mail.png",
    "/icons/stk/Miss2s.png",
    "/icons/stk/MoreInfo.png",
    "/icons/stk/MyVolume.png",
    "/icons/stk/NewProduct.PNG",
    "/icons/stk/Oh.png",
    "/icons/stk/Ok.png",
    "/icons/stk/Please1.PNG",
    "/icons/stk/Please2.png",
    "/icons/stk/Processing.png",
    "/icons/stk/ProductInterest.png",
    "/icons/stk/Quotation.png",
    "/icons/stk/ReadyDelivery.png",
    "/icons/stk/Rest.png",
    "/icons/stk/Rich.png",
    "/icons/stk/Roger.png",
    "/icons/stk/Slip.png",
    "/icons/stk/Sorry.jpeg",
    "/icons/stk/Sorry2.png",
    "/icons/stk/SpecialPrice.png",
    "/icons/stk/TakeCare.png",
    "/icons/stk/ThankForPayment.jpeg",
    "/icons/stk/ThankYou.png",
    "/icons/stk/Tired.png",
    "/icons/stk/Tuy.png",
    "/icons/stk/WaitMoment.png",
    "/icons/stk/Welcome.png",
    "/icons/stk/WhereDelivery.png",
    "/icons/stk/Worth.png"
  ];
  const hdrText = editId === null
    ? "ยังไม่ได้เลือก"
    : (editId === -1)
      ? "เพิ่มหัวข้อใหม่" : "รายละเอียด";

  useEffect(() => { 'CategoryEdit rendered' }, []);

  useEffect(() => {
    // console.log('editId is chnage to ' + editId);
    setModalData(null);
    if (editId === null) { // nothing
      setEditData(null);
      setEditItems([]);
    } else if (editId === -1) { // new
      setEditData({ enabled: true });
      setEditItems([getNewItem()]);
    } else { // load from database
      setIsLoading(true);
      const api = new APIClient();
      api.fnPostForm(urls.QUICK_REPLY_LOAD, { quickReplyId: editId })
        .then(rs => {
          // console.log('rs:', rs);
          setEditData(rs);
          const newItems = rs.items.map((x: any) => ({ ...x, uid: Utils.GetUniqueId() }));
          setEditItems(newItems);
          setShowMore(rs.category || rs.description || rs.avaliableFrom || rs.avaliableTo);
          setIsLoading(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setEditData(null);
          setEditItems([]);
          setIsLoading(false);
        });
    }
  }, [editId]);

  const [isSaving, setIsSaving] = useState<boolean>(false);
  const onSave = () => {
    try {
      if (!editData) {
        alert('กรุณาระบุชื่อ');
        return;
      }
      if (!editData.name) {
        alert('กรุณาระบุชื่อ');
        return;
      }
      setIsSaving(true);
      const dataToSave = { ...editData };
      dataToSave.items = [...editItems].sort((e1, e2) => (e1.seq ?? 0) - (e2.seq ?? 0));
      const api = new APIClient();
      api.fnPostBody(urls.QUICK_REPLY_SAVE, dataToSave)
        .then(rs => {
          // console.log('rs:', rs);
          setEditData(prev => ({ ...prev, quickReplyId: rs.quickReplyId }));
          onCatChange(rs.quickReplyId, rs);
          setIsSaving(false);
        })
        .catch(er => {
          Utils.HandleException(er, true);
          setIsSaving(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSaving(false);
    }
  }

  const onDelete = () => {
    Utils.SweetConfirm("ยืนยันการลบข้อมูล").then(x => {
      if (x.isConfirmed) {
        new APIClient().fnPostForm(urls.QUICK_REPLY_DEL, { quickReplyId: editData?.quickReplyId })
          .then(rs => {
            onCatChange(editData?.quickReplyId ?? -1, null);
          })
          .catch(er => {
            Utils.HandleException(er, true);
          });
      }
    });
  }

  const Header: React.FC<{}> = ({ }) => {
    return (
      <div className="mpage-2col-header">
        <div>{hdrText}</div>
        <div className="d-flex" style={{ gap: "10px" }}>
          {(editData && canEdit) && (
            <>
              {editData?.quickReplyId && (<button className="btn btn-pc btn-danger" onClick={onDelete} >ลบข้อมูล</button>)}
              {/* <button className="btn btn-pc btn-warning" >ยกเลิก</button> */}
              <button className="btn btn-pc btn-primary" onClick={onSave} >
                {isSaving && (<><LoadingIconWithText loadingText={""}></LoadingIconWithText>&nbsp;</>)}
                บันทึก
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  // const [editUid, setEditUid] = useState<string>("");


  const onTextChange = (value: string) => {
    setModalData(prev => ({ ...prev, text: value }))
  }

  const onConfirmModalAsync = async (): Promise<tb_QuickReplyItem | null> => {
    const rs: tb_QuickReplyItem = {};
    rs.contentType = modalData?.contentType;
    rs.contentName = modalData?.contentName;

    if (modalData?.contentType === Types.Text) {
      rs.contents = modalData?.text?.replaceAll('\n', '<br/>');
      return rs;
    } else if (modalData?.contentType === Types.Sticker) {
      rs.contents = modalData?.sticker;
      return rs;
    } else if (modalData?.contentType === Types.Picture || modalData?.contentType === Types.File) {
      const isImage = modalData?.contentType === Types.Picture;
      const input = isImage ? modalPictureRef.current : modalFileRef.current;
      if (!input || !input.files || input.files.length <= 0) throw new Error('ยังไม่ได้เลือกไฟล์');

      // upload picture
      const file = input.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("isImage", isImage ? "true" : "false");
      const response = await fetch(process.env.REACT_APP_APIURL + urls.QUICK_REPLY_UPLOAD_FILE, {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
        }
      });
      const rs2 = await response.json();
      // console.log('rs2:', rs2);
      const errMsg =
        rs2.errors && rs2.errors[""] && rs2.errors[""].length > 0
          ? rs2.errors[""][0]
          : null;

      if (rs2.error) {
        throw new Error(rs2.error);
      } else if (errMsg) {
        throw new Error(errMsg);
      } else if (rs2.title) {
        throw new Error(rs2.title);
      } else {
        rs.contents = isImage ? rs2.urlThumb : rs2.url;
        rs.contentName = file.name;
        return rs;
      }
    } else if (modalData?.contentType === Types.Link) {
      rs.contents = modalData.linkUrl;
      rs.contentName = modalData.linkCaption ?? modalData.linkUrl;
      return rs;
    }
    return null;
  }

  const onConfirmModal = () => {
    setModalSaving(true);
    try {
      // console.log('edititem:', editItems);
      // console.log('modal:', modalData);

      onConfirmModalAsync().then(rs => {
        if (rs) {
          setEditItems(prev => prev.map(xx => xx.uid == modalData?.uid ? ({
            ...xx,
            contentType: rs.contentType,
            contents: rs.contents,
            contentName: rs.contentName,
          }) : xx));
          setModalData(null);
        } else {
          alert('No data');
        }
        setModalSaving(false);
      }).catch(e => { alert(e.message); setModalSaving(false); });
    } catch (e) {
      Utils.HandleException(e, true);
      setModalSaving(false);
    }
  }

  // useEffect(() => { console.log('editItems:', editItems); }, [editItems]);

  const onClickEdit = (e: any, uid: string) => {
    // If the clicked element is inside an <a> tag, skip processing
    const anchor = (e.target as HTMLElement).closest('a');
    if (anchor) return;

    // console.log('click uid = ' + uid);
    //const found = editItems.find(x => x.uid === uid); // not create new object
    const found = { ...editItems.find(x => x.uid === uid) }; // create new object
    if (found) {
      const newContent = found.contents?.replaceAll("<br/>", "\n").replaceAll("<br>", "\n");
      setModalData({
        uid: found.uid,
        contentType: found.contentType,
        text: found.contentType === Types.Text ? newContent : "",
        sticker: found.contentType === Types.Sticker ? newContent : "",
        picture: found.contentType === Types.Picture ? newContent : "",
        linkUrl: (found.contentType === Types.File || found.contentType === Types.Link) ? newContent : "",
        linkCaption: (found.contentType === Types.File || found.contentType === Types.Link) ? found.contentName : "",
      });
    }
  }

  const setModalType = (val: any) => {
    const type = parseInt(val) as Types;
    setModalData(prev => ({
      ...prev
      , contentType: type
    }));
  }

  const onChooseSticker = (url: string, close: boolean) => {
    setModalData(prev => ({ ...prev, sticker: url }));
    if (close) {
      onConfirmModal();
    }
  }

  // useEffect(() => { console.log('modalData:', modalData); }, [modalData]);

  const modalPictureRef = useRef<HTMLInputElement>(null);
  const modalFileRef = useRef<HTMLInputElement>(null);

  const handleModalPictureClick = () => {
    modalPictureRef.current?.click(); // Trigger the file input dialog
  };

  const handleModalPictureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setModalData(prev => ({ ...prev, picture: e.target?.result as string }))
        // setImageSrc(e.target?.result as string); // Update the image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const swapEditItems = (seq1: number, direction: number) => {
    const seq2 = seq1 + direction;

    const total = editItems.length;
    if (seq1 == seq2 || seq1 < 0 || seq2 < 0 || seq1 > total || seq2 > total) return;
    // console.log('swap from ' + seq1 + ' to ' + seq2);

    setEditItems(prevItems => {
      // Clone the array to avoid mutation
      const newItems = [...prevItems];

      // Find the two items by index value
      const item1 = newItems.find(x => x.seq === seq1);
      const item2 = newItems.find(x => x.seq === seq2);

      if (!item1 || !item2) return prevItems; // Nothing to swap

      // Swap their index values
      const temp = item1.seq;
      item1.seq = item2.seq;
      item2.seq = temp;

      return [...newItems];
    });
  };

  const getNewItem = () => {
    return {
      uid: Utils.GetUniqueId(),
      quickReplyId: -1,
      seq: editItems.length + 1,
      contentType: Types.Text,
      contents: "",
      enabled: true,
    };
  }

  const addEditItems = () => {
    setEditItems(prev => [...prev, getNewItem()]);
  }

  if (editId === null) return (<Header />);
  return (
    <div style={{ position: "relative" }}>
      {/* Modal Edit Content */}
      <Modal isOpen={canEdit && (modalData ? true : false)} tabIndex={-1} role="dialog" size="lg" toggle={() => setModalData(null)}>
        <ModalHeader>
          แก้ไข
        </ModalHeader>
        <ModalBody className="">
          <RadioGroup row value={modalData?.contentType} onChange={(e) => setModalType(e.target.value)}>
            <FormControlLabel value={Types.Text} control={<Radio />} label="ข้อความ"></FormControlLabel>
            <FormControlLabel value={Types.Sticker} control={<Radio />} label="สติกเกอร์"></FormControlLabel>
            <FormControlLabel value={Types.Picture} control={<Radio />} label="รูปภาพ"></FormControlLabel>
            <FormControlLabel value={Types.File} control={<Radio />} label="ไฟล์"></FormControlLabel>
            <FormControlLabel value={Types.Link} control={<Radio />} label="ลิงค์"></FormControlLabel>
          </RadioGroup>
          <div className="dset-ar-modal-body">
            {modalData?.contentType === Types.Text && (
              <textarea style={{ width: "100%", height: "120px", padding: "10px" }} onChange={(e) => onTextChange(e.target.value)} value={modalData?.text ?? ""} ></textarea>
            )}
            {modalData?.contentType === Types.Sticker && (
              <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                {stickerList.map((url: string, index: number) => (
                  <img key={index} src={url} className={classnames("dset-ar-img-thumb hover hand", { "dset-ar-img-thumb-sel": url === modalData?.sticker })}
                    onClick={() => onChooseSticker(url, false)} onDoubleClick={() => onChooseSticker(url, true)}
                  ></img>
                ))}
              </div>
            )}
            {modalData?.contentType === Types.Picture && (
              <div>
                <img
                  src={modalData?.picture ?? ""/* || "https://cdn4.vectorstock.com/i/1000x1000/96/43/avatar-photo-default-user-icon-picture-face-vector-48139643.jpg"*/}
                  alt="Selected" className="chat-sticker hand hover"
                  onClick={handleModalPictureClick}
                  style={{ objectFit: "cover" }}
                />
                <input
                  type="file"
                  accept="image/*"
                  ref={modalPictureRef}
                  style={{ display: "none" }}
                  onChange={handleModalPictureChange}
                />
              </div>
            )}
            {modalData?.contentType === Types.File && (
              <input type="file" className="form-control" ref={modalFileRef} />
            )}
            {modalData?.contentType === Types.Link && (
              <>
                <div className="row m-1">
                  <div className="col">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend" style={{ minWidth: "100px" }}>
                        <span className="input-group-text" id="basic-addon1">URL</span>
                      </div>
                      <input type="text" className="form-control" placeholder="ระบุ URL ที่ต้องการ (ใส่ https ด้วย หากเป็น URL นอก)" value={modalData.linkUrl ?? ""} onChange={(e) => setModalData(prev => ({ ...prev, linkUrl: e.target.value }))}></input>
                    </div>
                  </div>
                </div>
                <div className="row m-1">
                  <div className="col">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend" style={{ minWidth: "100px" }}>
                        <span className="input-group-text" id="basic-addon1">Caption</span>
                      </div>
                      <input type="text" className="form-control" placeholder="ระบุชื่อที่จะแสดงของ URL" value={modalData.linkCaption ?? ""} onChange={(e) => setModalData(prev => ({ ...prev, linkCaption: e.target.value }))}></input>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-pc btn-warning" onClick={() => setModalData(null)}>ยกเลิก</button>
          <button className="btn btn-pc btn-primary" onClick={() => onConfirmModal()}>
            {modalSaving && (<LoadingIconWithText loadingText={""} />)}
            ตกลง
          </button>
        </ModalFooter>
      </Modal >

      {isLoading && (<Loader />)}

      <Header />
      <div className="row">
        <div className="col">
          ชื่อ&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <FormControlLabel
            control={
              <Switch checked={editData?.enabled ?? false}
                onChange={(e) => setEditData(p => ({ ...p, enabled: canEdit ? e.target.checked : p?.enabled }))}
              />
            }
            label={editData?.enabled ? "ใช้งาน" : "ไม่ใช้งาน"}
          />
          <TextBox className="form-control p-1" readOnly={!canEdit} value={editData?.name ?? ""} onChange={(e) => setEditData(p => ({ ...p, name: e.target.value }))}></TextBox>
        </div>
        <div className="col">
          <div className="d-flex align-items-center" style={{ height: "36px" }}>
            Keyword
          </div>
          <TextBox className="form-control p-1" readOnly={!canEdit} value={editData?.keyword ?? ""} onChange={(e) => setEditData(p => ({ ...p, keyword: e.target.value }))}></TextBox>
        </div>
      </div>

      <div className="row">
        <div className="col">
          รูปแบบข้อความ <i className="hand hover fas fa-plus-circle text-primary" onClick={addEditItems}></i>
        </div>
      </div>


      <div style={{ minHeight: "100px" }}>
        {[...editItems].sort((e1, e2) => (e1.seq ?? 0) - (e2.seq ?? 0)).map((item, index) => {
          const isFirst = index === 0;
          const isLast = index === editItems.length - 1;
          const cssClass =
            index === 0 ? "dset-qr-preview-top" :
              index === editItems.length - 1 ? "dset-qr-preview-bottom" : "dset-qr-preview-mid";
          return (
            <div key={index} className="row">
              <div className="col">
                <div className="d-flex justify-content-between">
                  <div className={cssClass + " hover hand"}>
                    {item.contentType === Types.Text && (
                      <div style={{ width: "100%" }} onClick={(e) => onClickEdit(e, item.uid ?? "")} dangerouslySetInnerHTML={{ __html: item.contents ? item.contents : "&nbsp;" }}>
                      </div>
                    )}
                    {item.contentType === Types.Sticker && (
                      <div onClick={(e) => onClickEdit(e, item.uid ?? "")}>
                        <img src={item.contents ?? ""} className="chat-sticker" ></img>
                      </div>
                    )}
                    {item.contentType === Types.Picture && (
                      <div onClick={(e) => onClickEdit(e, item.uid ?? "")} >
                        <img src={Utils.ConvertUrlIfItIsInternalChat(item.contents ?? "")} className="chat-sticker" ></img>
                      </div>
                    )}
                    {(item.contentType === Types.File || item.contentType === Types.Link) && (
                      <div onClick={(e) => onClickEdit(e, item.uid ?? "")} >
                        {!item.contents ? (<span>คลิ๊กเพื่อเลือกไฟล์</span>) : (<a href={item.contents ?? ""} target="_blank">{item.contentName ?? "คลิ๊กเพื่อดาวโหลด"}</a>)}
                      </div>
                    )}
                  </div>
                  {canEdit && (
                    <div className="ms-2 d-flex align-items-center" style={{ gap: "10px" }}>
                      <i className="hand hover far fa-arrow-alt-circle-up" onClick={(e) => swapEditItems(item.seq ?? 0, -1)}></i>
                      <i className="hand hover far fa-arrow-alt-circle-down" onClick={(e) => swapEditItems(item.seq ?? 0, +1)}></i>
                      <i className="hand hover fas fa-edit" onClick={(e) => onClickEdit(e, item.uid ?? "")}></i>
                      <i className="hand hover fas fa-trash-alt text-danger" onClick={(e) => setEditItems(prev => prev.filter(x => x.uid !== item.uid))}></i>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>

      <div className="row">
        <div className="col hand">
          <span onClick={(e) => setShowMore(prev => !prev)}><i className={iconShowMore}></i>&nbsp;ตัวเลือกเพิ่มเติม</span>
        </div>
      </div>

      {
        showMore && (
          <>
            <div className="row">
              <div className="col">
                ประเภท
                <TextBox className="form-control p-1" readOnly={!canEdit} value={editData?.category ?? ""} onChange={(e) => setEditData(x => ({ ...x, category: e.target.value }))}></TextBox>
              </div>
              <div className="col">
                คำอธิบาย
                <TextBox className="form-control p-1" readOnly={!canEdit} value={editData?.description ?? ""} onChange={(e) => setEditData(x => ({ ...x, description: e.target.value }))}></TextBox>
              </div>
            </div>
            <div className="row">
              <div className="col">
                ใช้ได้ตั้งแต่
                <DatePicker
                  selected={editData?.avaliableFrom} readOnly={!canEdit}
                  onChange={(date: any) => setEditData(x => ({ ...x, avaliableFrom: date }))}
                  dateFormat={"dd/MM/yyyy"} isClearable className="form-control p-1" portalId="root-portal"></DatePicker>
              </div>
              <div className="col">
                ใช้ได้ถึง
                <DatePicker
                  selected={editData?.avaliableTo} readOnly={!canEdit}
                  onChange={(date: any) => setEditData(x => ({ ...x, avaliableTo: date }))}
                  dateFormat={"dd/MM/yyyy"} isClearable className="form-control p-1" portalId="root-portal"></DatePicker>
              </div>
            </div>
          </>
        )
      }
      {/* {editData?.quickReplyId && (
        <div className="d-flex justify-content-between mt-2">
          &nbsp;
          <div>
            {canEdit && (<button className="btn btn-pc btn-danger" onClick={onDelete} >ลบข้อมูล</button>)}
          </div>
        </div>
      )} */}
    </div>

  );
}

const DataSettingQuickReply = () => {
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [canEdit, setCanEdit] = useState<boolean>(false);
  const [categories, setCategories] = useState<any[]>([]);
  // const [editData, setEditData] = useState<tb_QuickReply | null>(null);
  const onSearch = (filter: string) => {
    try {
      const api = new APIClient();
      setIsSearching(true);
      api.fnPostForm(urls.LOAD_QUICK_REPLY_CAT, { keyword: filter })
        .then(rs => {
          // console.log('LOAD_QUICK_REPLY_CAT:', rs);
          setCategories(rs.result);
          setCanEdit(rs.canEdit);
          setIsSearching(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setIsSearching(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSearching(false);
    }
  }

  useEffect(() => {
    onSearch("");
  }, []);

  const [editId, setEditId] = useState<number | null>(null);
  const onClickItem = (editId: number | null) => {
    setEditId(editId);
    // setEditCol2Key(editId);
  }

  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
    setEditId(key);
  }

  const onCatChange = (quickReplyId: number, data: tb_QuickReply | null) => {
    // console.log('onCatChange:', { quickReplyId, data });
    if (data == null) { // delete
      setCategories(prev => prev.filter(p => p.quickReplyId !== quickReplyId));
      setEditId(null);
      // setEditCol2Key(null);
    } else { // update
      const found = categories.some(x => x.quickReplyId === quickReplyId);
      if (found) { // update existing
        setCategories(prev => prev.map(p => p.quickReplyId === quickReplyId ? ({
          ...p,
          name: data.name,
          enabled: data.enabled,
          active: data.active
        }) : p));
      } else { // add new
        setCategories(prev => [...prev, data]);
        setEditId(data.quickReplyId ?? -1);
        // setEditCol2Key(data.quickReplyId ?? -1);
      }
    }
  }

  return (
    <MasterPage2Column
      titleText="ข้อมูล คลังคำตอบ ระบบ Chat"
      titleIcon="fas fa-atlas"
      editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<CategoryList onClickItem={onClickItem} editId={editId ?? -1} isSearching={isSearching} categories={categories} onSearch={onSearch} canEdit={canEdit} />}
      componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage2Column>
  );
}

export default DataSettingQuickReply;